var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({class:['notification-icon', _vm.classVariation]},'div',_vm.$attrs,false),_vm.$listeners),[_c('i',{class:['icon', _vm.iconVariation],attrs:{"data-test":"icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }